import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import VueI18n from "vue-i18n";
// import * as Sentry from "@sentry/browser";
import store from "./store";
import { KbContext } from "./models/KbContext";
import { GaEventManager } from "./GaEventManager";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

declare global {
  interface Window {
    kbContext: KbContext;
    linkTemplate: string;
    requestIdleCallback: (cb: any) => any;
    gaEventManager: GaEventManager;
  }
}

import Checkbox from "./checkbox/Checkbox.vue";
import Modal from "./modal/Modal.vue";
import TextInput from "./text-input/TextInput.vue";

function initVue(): void {
  const kbContextJsonEl = document.querySelector("#kbContextJson");

  if (kbContextJsonEl && kbContextJsonEl.textContent) {
    window.kbContext = KbContext.fromJson(kbContextJsonEl.textContent);
  } else {
    window.kbContext = new KbContext();
  }

  // Load configuration from page
  const configElement = document.getElementById("search_config");
  let config = {
    dsn: "",
    localization: {
      locale: "fr",
      domain: "default"
    }
  };
  if (configElement !== null) {
    config = JSON.parse(configElement!.innerHTML);
  }

  // Sentry.init({ dsn: config.dsn });

  // Custom components
  Vue.component("checkbox", Checkbox);

  Vue.component("modal", Modal);

  Vue.component("text-input", TextInput);

  Vue.component("login", () =>
    import(/* webpackChunkName: "others" */ "./login/Login.vue")
  );
  Vue.component("favorite-journey-button", () =>
    import(
      /* webpackChunkName: "others" */ "./favorite-journey-button/FavoriteJourneyButton.vue"
    )
  );
  Vue.component("email-collection", () =>
    import(
      /* webpackChunkName: "others" */ "./email-collection/EmailCollection.vue"
    )
  );
  Vue.component("compare-site", () =>
    import(
      "./search-engine/compare-site/CompareSite.vue" /* webpackChunkName: "compare-site" */
    )
  );
  Vue.component("search-engine", () =>
    import(
      "./search-engine/SearchEngine.vue" /* webpackChunkName: "search-engine" */
    )
  );
  Vue.component("optins", () =>
    import("./optins//Optins.vue" /* webpackChunkName: "optins" */)
  );
  Vue.component("add-to-home", () =>
    import("./add-to-home/AddToHome.vue" /* webpackChunkName: "add-to-home" */)
  );

  const baseDateConfig = {
    short: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    },
    date: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    }
  };

  const i18n = new VueI18n({
    locale: config.localization.locale,
    fallbackLocale: "fr",
    dateTimeFormats: {
      fr: baseDateConfig,
      it: baseDateConfig,
      es: baseDateConfig
    }
  });

  new Vue({
    store,
    i18n,
    el: "#app",
    mounted() {
      // Keep this event header, it's needed for prerender
      document.dispatchEvent(new Event("render-event"));
    }
  });
}

if ("requestIdleCallback" in window) {
  window.requestIdleCallback(initVue);
} else {
  initVue();
}
